var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342 0.0205078H0V341.32H513V0.0205078H342Z",
    fill: "#DC2339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0205078H171V342.021H0V0.0205078Z",
    fill: "#11865D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 0.0205078H342V342.021H171V0.0205078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.8 171.22C195.8 192.82 207.3 212.92 226.1 223.72C231.9 227.12 239.3 225.12 242.7 219.32C246.1 213.52 244.1 206.12 238.3 202.72C227 196.22 220.1 184.22 220.1 171.22C220.1 164.52 214.7 159.12 208 159.12C201.3 159.12 195.8 164.52 195.8 171.22ZM289.2 222.32C306.7 211.22 317.2 191.92 317.2 171.22C317.2 164.52 311.8 159.12 305.1 159.12C298.4 159.12 293 164.52 293 171.22C293 183.62 286.7 195.22 276.2 201.92C270.5 205.42 268.7 212.82 272.1 218.62C275.5 224.42 283 226.12 288.8 222.72C288.8 222.52 289 222.42 289.2 222.32Z",
    fill: "#8C9157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 195.521C269.921 195.521 280.8 179.224 280.8 159.121C280.8 139.018 269.921 122.721 256.5 122.721C243.08 122.721 232.2 139.018 232.2 159.121C232.2 179.224 243.08 195.521 256.5 195.521Z",
    fill: "#C59262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.0205078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMx);
export default __webpack_public_path__ + "static/media/MX.a9cb83bb87f6f727c31809909add646b.svg";
export { ForwardRef as ReactComponent };